import { Link } from 'react-router-dom'
import { Actions, Content, Message, SliderImage, SliderImageWrapper, StyledButton, Title, TitleHighlight, Wrapper } from './styles'

export default function Slide() {
  return (
    <Wrapper>
      <Content>
        <Title variant="h1">
          Celebrate together with <TitleHighlight>one simple link!</TitleHighlight>
        </Title>
        <Message>
          New Group Buckets is perfect for sharing memories of the big day with family and friends. You invite only the people you want to upload,
          download and share photos & videos, giving you total control and privacy.
        </Message>
        <Actions>
          <StyledButton color="inherit" component={Link} data-test="carousel-share-signup" to="auth/register" variant="outlined">
            Try it today!
          </StyledButton>
        </Actions>
      </Content>
      <SliderImageWrapper>
        <picture>
          <SliderImage
            sizes="(max-width: 1405px) 100vw, 1405px"
            srcSet="
              //content.photobucket.com/img/homepage/homepage-slider-wedding-0701-w200.webp 200w,
              //content.photobucket.com/img/homepage/homepage-slider-wedding-0701-w607.webp 607w,
              //content.photobucket.com/img/homepage/homepage-slider-wedding-0701-w889.webp 889w,
              //content.photobucket.com/img/homepage/homepage-slider-wedding-0701-w1105.webp 1105w,
              //content.photobucket.com/img/homepage/homepage-slider-wedding-0701-w1405.webp 1405w"
            src="//content.photobucket.com/img/homepage/homepage-slider-wedding-0701-w1405.webp"
            alt="A bride and two friends take a selfie that they will share on Photobucket!"
          />
        </picture>
      </SliderImageWrapper>
    </Wrapper>
  )
}
